import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Link,
} from '@mui/material';

function CoordinationSSN() {
  const lawLink = "/documents/lois/Loi-N°-1-18-du-24-juillet-2023-portant-organisation-du-SSN-du-Burundi.pdf"; 

  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
           <Container maxWidth="lg" style={{ paddingTop: '60px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Coordination du Système Statistique National (SSN)
        </Typography>

        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Composantes du SSN
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Le Système Statistique National (SSN) comprend les entités suivantes :
        </Typography>
        <ul>
          <li>
            <strong>Comité National de l'Information Statistique (CNIS) :</strong> Organe consultatif supervisant les activités statistiques et ayant la responsabilité de la diffusion des statistiques de souveraineté nationale.
          </li>
          <li>
            <strong>Comité Technique de l’Information Statistique (CTIS) :</strong> Fournit un soutien technique au CNIS et définit les normes à respecter.
          </li>
          <li>
            <strong>Autorité statistique nationale :</strong> Coordonne les activités statistiques et assure le secrétariat permanent du CNIS.
          </li>
          <li>
            <strong>Services statistiques gouvernementaux :</strong> Élaborent des données statistiques auprès des départements ministériels et organismes publics.
          </li>
          <li>
            <strong>Institutions de formation :</strong> Contribuent à la professionnalisation en statistiques et démographie.
          </li>
        </ul>

        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Responsabilités du SSN
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Les entités du SSN sont responsables de :
        </Typography>
        <ul>
          <li>Élaboration et diffusion de données statistiques conforme à la législation en vigueur.</li>
          <li>Protection de la confidentialité des données individuelles.</li>
          <li>Formation des acteurs sur les méthodes de collecte et l'importance des statistiques.</li>
        </ul>

        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Publication et Accès aux Données
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Les données statistiques officielles sont validées par le CTIS avant publication, garantissant ainsi leur qualité. Tous les usagers, y compris les institutions publiques, ont un accès équitable aux statistiques officielles selon un calendrier de diffusion établi.
        </Typography>

        <Typography variant="h6" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Protection des Données Individuelles
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Les membres du SSN doivent respecter le secret statistique, s'assurant que les informations individuelles restent confidentielles et ne sont utilisées qu'à des fins statistiques. Les chercheurs peuvent accéder aux bases de données protégées, sous condition de respect de la confidentialité.
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Pour plus d’informations sur les lois régissant le Système Statistique National, consultez la loi n° <Link href={lawLink} target="_blank" rel="noopener noreferrer" style={{ color: 'red', transition: 'color 0.3s ease' }}>18/ du 24 juillet 2023</Link>.
        </Typography>
      </Container>
      <Footer />
    </div>
  );
}

export default CoordinationSSN;